import { render, staticRenderFns } from "./TokenManager.vue?vue&type=template&id=20e0435d"
import script from "./TokenManager.vue?vue&type=script&lang=js"
export * from "./TokenManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports